// Login.tsx
import React, { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../msalConfig';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaWindows } from 'react-icons/fa';

import backgroundImg from '../assets/background.svg';
import brandLogo from '../assets/codelab admin left.png';

const Login = () => {
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as any)?.from
    ? (location.state as any).from.pathname +
    (location.state as any).from.search
    : '/dashboard';
  
  useEffect(() => {
    if (accounts?.length > 0) {
      navigate(from, { replace: true });
    }
  }, [from]);

  const handleLogin = async () => {
    try {
      const loginResponse = await instance.loginPopup(loginRequest);
      if (loginResponse?.account) {
        navigate(from, { replace: true });
      }
    } catch (error) {
      console.error('Login error:', error);
    }
  };

  const outerContainerStyle: React.CSSProperties = {
    minHeight: '100vh',
    backgroundImage: `url(${backgroundImg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const modalContainerStyle: React.CSSProperties = {
    width: '500px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: '8px',
    boxShadow: '0 0 20px rgba(0,0,0,0.3)',
    padding: '2rem',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    backdropFilter: 'blur(10px)',
  };

  const logoStyle: React.CSSProperties = {
    maxWidth: '300px',
    marginBottom: '1.5rem',
  };

  const buttonStyle: React.CSSProperties = {
    marginTop: '1rem',
    backgroundColor: '#D1CC00',
    border: 'none',
    color: '#000',
    fontSize: '1.25rem',
    fontWeight: 600,
    cursor: 'pointer',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    height: '50px',
    width: '220px',
    borderRadius: '4px',
  };

  return (
    <div style={outerContainerStyle}>
      <div style={modalContainerStyle}>
        <img src={brandLogo} alt="Brand Logo" style={logoStyle} />
        <button onClick={handleLogin} style={buttonStyle}>
          <span style={{ display: 'inline-flex', alignItems: 'center' }}>
            <div style={{ color: '#333333' }}>LOG IN</div>
            <FaWindows style={{ marginLeft: 10, color: '#333333' }} />
          </span>
        </button>
      </div>
    </div>
  );
};

export default Login;
